import { apiSlice } from "../../app/api/apiSlice";

export const lockExtensionPolicyApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		lockExtensionPolicy: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loan/get_ob_lock_extension_policy/",
				method: "POST",
				body: body,
			}),
		}),
	}),
});

export const { useLockExtensionPolicyMutation } = lockExtensionPolicyApiSlice;

